import type { WildfireStatsResponse, TodayStatsResponse, HistoricalComparison, FireStatsResponse } from './statsTypes';

const BASE_URL = '/api/stats';

export async function fetchWildfireStats(year?: number): Promise<WildfireStatsResponse> {
  const url = year ? `${BASE_URL}/wildfire?year=${year}` : `${BASE_URL}/wildfire`;
  const res = await fetch(url, { credentials: 'include' });
  if (!res.ok) {
    throw new Error(`Failed to fetch wildfire stats: ${res.status} ${res.statusText}`);
  }
  return res.json();
}

export async function fetchTodayStats(year?: number): Promise<TodayStatsResponse> {
  const url = year ? `${BASE_URL}/wildfire/today?year=${year}` : `${BASE_URL}/wildfire/today`;
  const res = await fetch(url, { credentials: 'include' });
  if (!res.ok) {
    throw new Error(`Failed to fetch today stats: ${res.status} ${res.statusText}`);
  }
  return res.json();
}

export async function fetchHistoricalStats(): Promise<HistoricalComparison[]> {
  const res = await fetch(`${BASE_URL}/wildfire/historical`, { credentials: 'include' });
  if (!res.ok) {
    throw new Error(`Failed to fetch historical stats: ${res.status} ${res.statusText}`);
  }
  return res.json();
}

export async function fetchFireStats(fireId: string): Promise<FireStatsResponse> {
  const res = await fetch(`${BASE_URL}/wildfire/${encodeURIComponent(fireId)}`, { credentials: 'include' });
  if (!res.ok) {
    throw new Error(`Failed to fetch fire stats: ${res.status} ${res.statusText}`);
  }
  return res.json();
}
